//Loading Types
export const SET_LOADING = 'SET_LOADING';
export const REMOVE_LOADING = 'REMOVE_LOADING';

//Toast Types
export const SET_MESSAGE = 'SET_MESSAGE';

export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const SET_ROUTE = 'SET_ROUTE';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

export const SIGN_IN = 'SIGN_IN';
export const SIGN_UP = 'SIGN_UP';
export const SIGN_OUT = 'SIGN_OUT';

//Dialog Types
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';

//Brand Types
export const GET_BRANDS = 'GET_BRANDS';
export const ADD_BRAND = 'ADD_BRAND';
export const UPDATE_BRAND = 'UPDATE_BRAND';
export const DELETE_BRAND = 'DELETE_BRAND';

//Master UPC List Types
export const GET_UPCLIST = 'GET_UPCLIST';
export const ADD_UPCLIST = 'ADD_UPCLIST';
export const UPDATE_UPCLIST = 'UPDATE_UPCLIST';
export const DELETE_UPCLIST = 'DELETE_UPCLIST';

//Invoice Records Types
export const GET_INVOICE_RECORDS = 'GET_INVOICE_RECORDS';
export const GET_BRAND_RECORDS = 'GET_BRAND_RECORDS';
export const GET_SEGMENT_RECORDS = 'GET_SEGMENT_RECORDS';
export const GET_USER_RECORDS = 'GET_USER_RECORDS';
export const GET_STATUS_RECORDS = 'GET_STATUS_RECORDS';

//Upload History Types
export const GET_UPLOAD_HISTORY = 'GET_UPLOAD_HISTORY';
export const VIEW_PARSED_RESULT = 'VIEW_PARSED_RESULT';

//Quickbooks Types
export const QB_SET_AUTH = 'QB_SET_AUTH';
export const QB_REMOVE_AUTH = 'QB_REMOVE_AUTH';

export const QB_CONNECT = 'QB_CONNECT';
export const QB_DISCONNECT = 'QB_DISCONNECT';
export const QB_OPEN_AUTH = 'QB_OPEN_AUTH';

export const QB_GET_LOGS = 'QB_GET_LOGS';
export const QB_GET_LOGS_BY_BATCHID = 'QB_GET_LOGS_BY_BATCHID';

//DOCPARSER
export const DP_GET_PARSERS = 'DP_GET_PARSERS';
export const DP_UPDATE_PARSER_NOTE_BY_ID = 'DP_UPDATE_PARSER_NOTE_BY_ID';

export const DP_ADD_PARSED_RESULT = 'DP_ADD_PARSED_RESULT';
export const DP_GET_PARSED_RESULT = 'DP_GET_PARSED_RESULT';
export const DP_GET_PARSED_RESULT_BY_BATCHID = 'DP_GET_PARSED_RESULT_BY_BATCHID';
export const DP_GET_PARSED_DATA_BY_ID = 'DP_GET_PARSED_DATA_BY_ID';
export const DP_GET_FILTER_OPTIONS = 'DP_GET_FILTER_OPTIONS';

//PDF MANIPULATOR
export const PDF_UPLOAD = 'PDF_UPLOAD';
export const PDF_UPLOAD_DELETE = 'PDF_UPLOAD_DELETE';
export const PDF_UPLOAD_CLEAR = 'PDF_UPLOAD_CLEAR';
export const PDF_GET_LOGS = 'PDF_GET_LOGS';
export const PDF_ADD_LOGS = 'PDF_ADD_LOGS';
export const PDF_SPLIT = 'PDF_SPLIT';
export const PDF_MERGE = 'PDF_MERGE';

//EDI
export const EDI_GET_BRANDS = 'EDI_GET_BRANDS';
export const EDI_IMPORT_FILE = 'EDI_IMPORT_FILE';
export const EDI_EXTRACT_FILE = 'EDI_EXTRACT_FILE';
export const EDI_LOAD_RESULTS = 'EDI_LOAD_RESULTS';
export const EDI_LOAD_ITEMS_BY_HEADER_ID = 'EDI_LOAD_ITEMS_BY_HEADER_ID';

//GMAIL
export const GMAIL_LOAD_MESSAGES = 'GMAIL_LOAD_MESSAGES';
export const GMAIL_LOAD_ATTACHMENT = 'GMAIL_LOAD_ATTACHMENT';